import React from "react"
import { Link } from "gatsby"
import styled, { StyleSheetManager } from "styled-components"
import Logo from "../images/sample write2smile 100.png"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const Padding = styled.div`
  height: 5px;
  width: 100%;
`
const Wrapper = styled.section`
  @import url("https://fonts.googleapis.com/css?family=Open+Sans:600&display=swap");
  * {
    box-sizing: border-box;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 0;
    margin: 0;
  }

  .card {
    font-family: "Open Sans", sans-serif;
    padding: 30px;
    background: #f1f0ea;
    /* background-color: #f9484a;
    background-image: linear-gradient(315deg, #f9484a 0%, #fbd72b 74%); */
    color: black;
    .about {
      h2 {
        padding: 10px 0;
      }
      h1 {
        padding: 15px 0;
      }
      h3 {
        padding: 15px 0;
      }
      p {
        text-align: justify;
      }
    }
    .purpose {
      h3 {
        padding: 15px 0;
      }
    }

    .dlink {
      h3 {
        padding: 15px 0;
      }
    }

    .wlink {
      h3 {
        padding: 15px 0;
      }
    }
  }
`

const Navbar = styled.div`
  display: flex;
  flex-direction: row;
  background: #a934bc;
  padding-bottom: 0px;
  .navbar {
    justify-items: center;
    h1 {
      padding-top: 30px;
      font-size: 28px;
      /* padding-left: 10px; */
      padding: 30px;
      color: white;
    }
    .logo {
      padding-left: 30px;
      padding-top: 15px;

      img {
        width: 100px;
        height: 100px;
        margin-left: auto;
        margin-right: auto;
        display: block;
      }
    }
  }
`

const Discp = styled.div`
  padding: 20px;
  padding-top: 40px;
  background-color: #ffd400;
  /* background-image: linear-gradient(315deg, #fbb034 0%, #ffdd00 74%); */
  h4 {
    padding: 0;
    text-align: justify;
  }
`
const Footer = styled.div`
  width: 100%;
  height: 60px;
  /* align-content: center; */
  text-align: center;
  /* top: 0;
  right: 0;
  left: 0;
  bottom: 0; */
  background: black;
  .creds {
    padding-top: 18px;
    color: white;
    /* text-align: center; */
    a {
      color: #00f704;
      text-decoration: none;
    }
    .heart {
      color: red;
    }
  }
`
const IndexPage = () => (
  // <Layout>
  //   <SEO title="Home" />
  //   <h1>Hi people</h1>
  //   <p>Welcome to your new Gatsby site.</p>
  //   <p>Now go build something great.</p>
  //   <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
  //     <Image />
  //   </div>
  //   {/* <Link to="/page-2/">Go to page 2</Link> */}
  // </Layout>
  <div>
    <Navbar>
      <div class="navbar">
        <div class="logo">
          <img src={Logo} />
        </div>
        <h1>Write2Smile extends support to the Covid-19 Warriors.</h1>
      </div>
    </Navbar>
    <Discp>
      <div class="disc">
        <h4>
          The following Organizations are 80G Certification Affiliated.
          Contributions made to certain relief funds and charitable institutions
          can be claimed as a deduction under Section 80G of the Income Tax Act.
        </h4>
      </div>
    </Discp>
    <Wrapper>
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Doctors for You</h1>
          <h3>About Us:</h3>
          <p>
            Doctors For You (DFY) is a pan India humanitarian organization with
            international presence and is working in various disaster hit zones
            since last 9 years.DFY focuses on providing medical care to the
            vulnerable communities during crisis and non-crisis situation,
            emergency medical aid to people affected by natural disaster,
            conflicts and epidemics.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Providing Medical Infrastructure</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://milaap.org/stories/doctors-for-youv?utm_source=facebook&utm_medium=cpc">
            https://milaap.org/stories/doctors-for-youv?utm_source=facebook&utm_medium=cpc
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="http://doctorsforyou.org">http://doctorsforyou.org/</a>
        </div>
      </div>
      {/* 2*/}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Yuva Parivartan</h1>
          <h3>About Us:</h3>
          <p>
            Yuva Parivartan is a collective effort of transformers, visionaries,
            corporates and the benefactors. An NGO which was cradled in the
            Kherwadi region of Bandra is now brimming with endless energy and
            has spread across the entire nation. In 19 years of its existence,
            Yuva Parivartan has shown a tremendous growth. The parent centre has
            now branched out to over 650 centres across 18 states of India which
            includes 67 Livelihood Development Centres, more than 600
            Partnership Centres, 5 Jail Centres and over 3000 mobile rural
            camps.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Providing Food</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://milaap.org/fundraisers/support-youth-for-unity-and-voluntary-action  ">
            https://milaap.org/fundraisers/support-youth-for-unity-and-voluntary-action
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://www.yuvaparivartan.org/">
            https://www.yuvaparivartan.org/
          </a>
        </div>
      </div>
      {/* 3 */}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Feeding India</h1>
          <h3>About Us:</h3>
          <p>
            Zomato Feeding India has a network of 24,500+ volunteers present
            across 100+ cities in India, and has served 33+ million (3.3+ Crore)
            meals to people in need. Our beneficiaries include and are not
            limited to - children, women, the elderly, specially-abled and
            migrant labourers. Through our five key programs and with the help
            of our volunteers - our Hunger Heroes, we redistribute surplus
            healthy meals to those who don’t have adequate or regular access to
            it.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Providing Food</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://www.feedingindia.org/donate">
            https://www.feedingindia.org/donate
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://www.feedingindia.org/">
            https://www.feedingindia.org/
          </a>
        </div>
      </div>

      {/* 4 */}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Public Health Foundation of India</h1>
          <h3>About Us:</h3>
          <p>
            The Public Health Foundation of India (PHFI) is a public private
            initiative that has collaboratively evolved through consultations
            with multiple constituencies including Indian and international
            academia, state and central governments, multi & bi-lateral agencies
            and civil society groups. PHFI is a response to redress the limited
            institutional capacity in India for strengthening training, research
            and policy development in the area of Public Health.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Providing Medical Infrastructure</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://phfi.org/donate/">https://phfi.org/donate/</a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://phfi.org/">https://phfi.org/</a>
        </div>
      </div>

      {/* 5 */}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Rapid Resnponse</h1>
          <h3>About Us:</h3>
          <p>
            Rapid Response is a registered non-profit organisation committed to
            provide emergency assistance and long term solutions to victims of
            disasters. India is one of the most disaster prone countries in the
            world, 23 out of 29 states are multi-disaster prone regions. Over 40
            million hectare of land has been identified as flood prone. About
            57% of the total area is vulnerable to earthquake of varying
            intensities. The Indian Ocean is one among the six key cyclone-prone
            regions of the world. The coromandel coastal line is more prone,
            about 80% of the total cyclones generated in the region hit here.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Providing Food</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://www.rapidresponse.org.in/coronavirusrelief.html">
            https://www.rapidresponse.org.in/coronavirusrelief.html{" "}
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://www.rapidresponse.org.in/">
            https://www.rapidresponse.org.in/
          </a>
        </div>
      </div>

      {/* 6 */}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Muskurahat Foundation</h1>
          <h3>About Us:</h3>
          <p>
            Muskurahat has evolved a two-fold theory of change. Our main aim is
            to expose our children to those skills of personality building and
            quality thinking that are ignored in schools. For this, Muskurahat
            has evolved its own theory of Social Change. We call it the Special
            Model of Social Difference (SMSD) based on (their) surroundings and
            upbringing. it.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Child and women education and welfare.</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://muskurahat.org.in/donate/">
            https://muskurahat.org.in/donate/
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://muskurahat.org.in">https://muskurahat.org.in</a>
        </div>
      </div>

      {/* 7 */}
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Oxfam India</h1>
          <h3>About Us:</h3>
          <p>
            Oxfam India provides urgent assistance to communities at risk in
            times of natural disasters and conflict. We ensure that they realise
            their right to clean water, food, sanitation and other fundamental
            needs. In particular, we reach out to women, adolescent girls,
            children, persons with disability and elderly people among these
            communities. An equally important aspect of our work is disaster
            risk reduction, or resilience of communities to natural disasters
            and conflicts.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>Supporting the Government</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://www.oxfamindia.org/girl-child-education-mgp?utm_source=google-ads-search&utm_medium=google-cpc&utm_campaign=google-ads-brand-search&gclid=CjwKCAjwguzzBRBiEiwAgU0FT43rzLrlOLSf_wT5dUbg3HKxMkgXD-N1GIoRdGyk_yBv54S0w1ZdJRoCeDgQAvD_BwE">
            https://www.oxfamindia.org/girl-child-education-mgp?utm_source=google-ads-search&utm_medium=google-cpc&utm_campaign=google-ads-brand-search&gclid=CjwKCAjwguzzBRBiEiwAgU0FT43rzLrlOLSf_wT5dUbg3HKxMkgXD-N1GIoRdGyk_yBv54S0w1ZdJRoCeDgQAvD_BwE{" "}
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://www.oxfamindia.org/">https://www.oxfamindia.org/</a>
        </div>
      </div>
    </Wrapper>

    {/* 8 */}
    <Wrapper>
      <Padding />
      <div class="card">
        <div class="about">
          <h2>Organization:</h2>
          <h1>Uday Foundation</h1>
          <h3>About Us:</h3>
          <p>
            We believe, that providing mere basic health care is not enough, as
            every individual also deserves dignity, at Uday Foundation, we
            ensure the same by providing them respect, human touch, basic health
            care, free food and dry ration through compassionate approach. Every
            month we receive tons of in-kind help from our generous donors
            enabling us to sustain our operations.
          </p>
        </div>
        <div class="purpose">
          <h3>Purpose of Work:</h3>
          <p>A dedicated Coronavirus 'Care Kit' for the homeless.</p>
        </div>
        <div class="dlink">
          <h3>Donation Link:</h3>
          <a href="https://www.udayfoundation.org/coronavirus-disease-covid-19/">
            https://www.udayfoundation.org/coronavirus-disease-covid-19/
          </a>
        </div>
        <div class="wlink">
          <h3>Main Website Link:</h3>
          <a href="https://www.udayfoundation.org/">
            https://www.udayfoundation.org/
          </a>
        </div>
      </div>
    </Wrapper>
    <Padding />

    <Footer>
      <div class="creds">
        <h5>
          Made By{" "}
          <a href="https://www.linkedin.com/in/gurukiran-d-nayak-56698514b/">
            Gurukiran
          </a>{" "}
          with <a class="heart">❤</a>
        </h5>
      </div>
    </Footer>
  </div>
)

export default IndexPage
